export enum TYRES_STORAGE_KEYS {
  ManufacturerPreference = "tyres-manufacturer-preference",
  DescriptionPreference = "tyres-description-preference",
  EanPreference = "tyres-ean-preference",
  CarryCapacityPreference = "tyres-carry-capacity-preference",
  WidthPreference = "tyres-width-preference",
  HeightPreference = "tyres-height-preference",
  SizePreference = "tyres-size-preference",
  SpeedPreference = "tyres-speed-preference",
  SeasonPreference = "tyres-season-preference",
  PageSizePreference = "tyres-page-size-preference"
}
